/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddOrderDto,
  ErrorMessage,
  InitiatedCartPaymentDto,
  PayCartDto,
  SubmittedDigitalBillDto,
} from '../models';
import {
    AddOrderDtoFromJSON,
    AddOrderDtoToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    InitiatedCartPaymentDtoFromJSON,
    InitiatedCartPaymentDtoToJSON,
    PayCartDtoFromJSON,
    PayCartDtoToJSON,
    SubmittedDigitalBillDtoFromJSON,
    SubmittedDigitalBillDtoToJSON,
} from '../models';

export interface AddOrderV3Request {
    reference: string;
    addOrderDto: AddOrderDto;
}

export interface PayCartV8Request {
    payCartDto: PayCartDto;
}

/**
 * 
 */
export class SubmitCartControllerApi extends runtime.BaseAPI {

    /**
     */
    async addOrderV3Raw(requestParameters: AddOrderV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmittedDigitalBillDto>> {
        if (requestParameters.reference === null || requestParameters.reference === undefined) {
            throw new runtime.RequiredError('reference','Required parameter requestParameters.reference was null or undefined when calling addOrderV3.');
        }

        if (requestParameters.addOrderDto === null || requestParameters.addOrderDto === undefined) {
            throw new runtime.RequiredError('addOrderDto','Required parameter requestParameters.addOrderDto was null or undefined when calling addOrderV3.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v3/digital-bills/{reference}/orders`.replace(`{${"reference"}}`, encodeURIComponent(String(requestParameters.reference))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrderDtoToJSON(requestParameters.addOrderDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmittedDigitalBillDtoFromJSON(jsonValue));
    }

    /**
     */
    async addOrderV3(requestParameters: AddOrderV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmittedDigitalBillDto> {
        const response = await this.addOrderV3Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async payCartV8Raw(requestParameters: PayCartV8Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitiatedCartPaymentDto>> {
        if (requestParameters.payCartDto === null || requestParameters.payCartDto === undefined) {
            throw new runtime.RequiredError('payCartDto','Required parameter requestParameters.payCartDto was null or undefined when calling payCartV8.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v8/carts/pay`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PayCartDtoToJSON(requestParameters.payCartDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitiatedCartPaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async payCartV8(requestParameters: PayCartV8Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitiatedCartPaymentDto> {
        const response = await this.payCartV8Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
